import { useRoutes } from "react-router-dom";

import { Routes } from "../routes/Routes";

const UnauthorizerNode = (authSelector) => {
return useRoutes(Routes(undefined));
};
export default UnauthorizerNode;
